import { Groupe, GroupeCreateInput, GroupeListResponse, GroupeResponse, GroupeSelectInput, GroupeUpdateInput } from "@repo/types";
import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';
import { BaseApiService } from './base-api.service';
export class GroupeService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.GROUPES.BASE, axios);
  }

  async getGroupes(filters: GroupeSelectInput): Promise<GroupeListResponse> {
    const { page = 1, limit = 10, ...rest } = filters;
    return this.getPaginated({ page, limit, ...rest });
  }

  async getGroupeById(id: number): Promise<GroupeResponse> {
    return this.get<GroupeResponse>(`/${id}`);
  }

  async createGroupe(data: GroupeCreateInput): Promise<GroupeResponse> {
    return this.post<GroupeResponse, GroupeCreateInput>('', data);
  }

  async updateGroupe(id: number, data: GroupeUpdateInput): Promise<GroupeResponse> {
    return this.put<GroupeResponse, GroupeUpdateInput>(`/${id}`, data);
  }

  async deleteGroupe(id: number): Promise<GroupeResponse> {
    return this.delete<GroupeResponse>(`/${id}`);
  }

  async getGroupesSelect(filters: GroupeSelectInput): Promise<GroupeListResponse> {
    const { page = 1, limit = 10, ...rest } = filters;
    return this.getPaginated<Groupe>({ page, limit, ...rest }, "/select");
  }

  async activateGroupe(id: number): Promise<GroupeResponse> {
    return this.put<GroupeResponse>(`/${id}/activate`);
  }

  async toggleStrippedStatus(id: number, isStripped?: boolean): Promise<GroupeResponse> {
    return this.post<GroupeResponse>(`/${id}/toggle-stripped`, { isStripped });
  }

  async getUsageStats(id: number): Promise<any> {
    return this.get<any>(`/${id}/usage-stats`);
  }

  async getSubscription(id: number): Promise<any> {
    return this.get<any>(`/${id}/subscription`);
  }

  async updateUsageAndExpiry(id: number, payload: {
    date_echeance?: string;
    max_parcours_per_month?: number;
    current_month_parcours?: number;
    plan_type?: string;
    subscription_status?: string;
    tier_id?: string;
  }): Promise<GroupeResponse> {
    return this.patch<GroupeResponse, typeof payload>(`/${id}/subscription/usage-expiry`, payload);
  }

  async uploadLogo(groupeId: number, file: File): Promise<string> {
    const formData = new FormData();
    formData.append('logo', file);

    const response = await this.axios.post(`${this.endpoint}/${groupeId}/logo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data.logoUrl || response.data.img_logo;
  }
}
